module.exports = __webpack_public_path__ + "assets/fdf37a1e77f654b4afa4287a10885269.mp3";